@if (searchService.search_loading) {
  <app-loading-screen icon="ico-car" [animated]="animated">
    <span title i18n="@@carsLoading_title">Just loading your search results</span>
    <div msgOne><span i18n="@@carsLoagind_msg1">Cars for </span>{{ locationName | titlecase }}</div>
    <span msgTwo i18n="@@carsLoagind_msg2">Checking for availability</span>
  </app-loading-screen>
}
